// extracted by mini-css-extract-plugin
export default {"FormWrapper":"vendor-address_FormWrapper__Qk8+q","FormField--TwoCol":"vendor-address_FormField--TwoCol__g4doK","FormField--FullCol":"vendor-address_FormField--FullCol__EuTET"};